import React, {
    ReactElement,
} from 'react';
import PageTemplate from 'page_template';
import HeaderCard from 'components/header_card';
import Button from 'components/button';
import * as PATHS from 'routing/paths';

import {
    Container,
    Inner,
    ColumnsSx,
} from './styles/documents_page.style';
import {
    Heading,
    Content,
    DocuemtnsContainer,
    DocumentsText,
    List,
    ListItem,
    RowList,
} from './styles/landing_page_documents.style';

// add navagation to login page if they are not already logged in

export default function DocumentLandingPage() {
    return (
        <PageTemplate active="documents">
            <HeaderCard bkgSrc="/images/headers/Textbooks.jpg">
                <HeaderCard.Title>Documents</HeaderCard.Title>
            </HeaderCard>
            <Container>
                <Inner>
                    <RowList>
                        <ListItem>
                            <h2 style={{ textAlign: 'center' }}>Handbook</h2>
                            <div style={{ position: 'relative', width: 399, height: 562 }}>
                                <embed
                                src="/files/Clarkson_Honors_Handbook_2025-2026.pdf"
                                type="application/pdf"
                                width="100%"
                                height="100%"
                                />
                                <a
                                href="/files/Clarkson_Honors_Handbook_2025-2026.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Open PDF in new window"
                                style={{ position: 'absolute', inset: 0 }}
                                />
                            </div>
                            </ListItem>
                        <ListItem>
                            <h2 style={{ textAlign: 'center' }}>Capstone Guide</h2>
                            <div style={{ position: 'relative', width: 399, height: 562 }}>
                                <embed
                                src="/files/Honors Capstone Guide 2024.pdf"
                                type="application/pdf"
                                width="100%"
                                height="100%"
                                />
                                <a
                                href="/files/Honors Capstone Guide 2024.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Open PDF in new window"
                                style={{ position: 'absolute', inset: 0 }}
                                />
                            </div>
                        </ListItem>
                    </RowList>   
                    <RowList>
                         <ListItem>
                            <h2 style={{ textAlign: 'center' }}>Traditional Research Capstone</h2>
                            <div style={{ position: 'relative', width: 399, height: 562 }}>
                                <embed
                                src="/files/Traditional Research Capstone Guide.pdf"
                                type="application/pdf"
                                width="100%"
                                height="100%"
                                />
                                <a
                                href="/files/Traditional Research Capstone Guide.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Open PDF in new window"
                                style={{ position: 'absolute', inset: 0 }}
                                />
                            </div>
                        </ListItem>
                        <ListItem>
                            <h2 style={{ textAlign: 'center' }}>Service Learning Capstone</h2>
                            <div style={{ position: 'relative', width: 399, height: 562 }}>
                                <embed
                                src="/files/The Service Learning Capstone Guide.pdf"
                                type="application/pdf"
                                width="100%"
                                height="100%"
                                />
                                <a
                                href="/files/The Service Learning Capstone Guide.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Open PDF in new window"
                                style={{ position: 'absolute', inset: 0 }}
                                />
                            </div>
                        </ListItem>
                    </RowList>
                    <RowList>
                        <ListItem>
                            <h2 style={{ textAlign: 'center' }}>Creative Capstone</h2>
                            <div style={{ position: 'relative', width: 399, height: 562 }}>
                                <embed
                                src="/files/The Creative Capstone Guide.pdf"
                                type="application/pdf"
                                width="100%"
                                height="100%"
                                />
                                <a
                                href="/files/The Creative Capstone Guide.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Open PDF in new window"
                                style={{ position: 'absolute', inset: 0 }}
                                />
                            </div>
                        </ListItem>
                        <ListItem>
                            <h2 style={{ textAlign: 'center' }}>Business Research Capstone</h2>
                            <div style={{ position: 'relative', width: 399, height: 562 }}>
                                <embed
                                src="/files/Business Research Capstone Guide.pdf"
                                type="application/pdf"
                                width="100%"
                                height="100%"
                                />
                                <a
                                href="/files/Business Research Capstone Guide.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Open PDF in new window"
                                style={{ position: 'absolute', inset: 0 }}
                                />
                            </div>
                        </ListItem>
                    </RowList> 
                    <RowList>
                        <ListItem>
                            <h2 style={{ textAlign: 'center' }}>Internship Capstone</h2>
                            <div style={{ position: 'relative', width: 399, height: 562 }}>
                                <embed
                                src="/files/The Internship Capstone Guide.pdf"
                                type="application/pdf"
                                width="100%"
                                height="100%"
                                />
                                <a
                                href="/files/The Internship Capstone Guide.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Open PDF in new window"
                                style={{ position: 'absolute', inset: 0 }}
                                />
                            </div>
                        </ListItem>
                    </RowList>
                </Inner>
            </Container>
        </PageTemplate>
    );
}

{/*
DocumentsLandingPage.DocumentsButton = function DocumentsLandingPageTextbooksButton({ children, ...otherProps }) {
    return (
        <DocumentsContainer>
            <Button variant="contained" border="rounded" {...otherProps}>
                <DocumentsText to={PATHS.DOCUMENTS + '/need_to_put_pathing_here'} state={{ from: location.pathname }}>{children}</DocumentsText>
            </Button>
        </DocumentsContainer>
    );
};*/}